import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* updateJourneyServices(params) {
  try {
    const journey = yield call(function() {
      return Api.put(`/journey/${params.id}/services`, {servicesProperty: params.body})
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'UPDATE_JOURNEY_SERVICES.SUCCESS', journey});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: journey.body.interventionId});
  } catch (error) {
    yield put({type: 'UPDATE_JOURNEY_SERVICES.FAILURE', error});
  }
}

export function* watchUpdateJourneyServices() {
  yield takeEvery('UPDATE_JOURNEY_SERVICES.REQUEST', updateJourneyServices)
}

function* updateJourneyMobility(params) {
  try {
    const journey = yield call(function() {
      return Api.put(`/journey/${params.id}/mobility`, {mobilityProperty: params.body})
    });
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'UPDATE_JOURNEY_MOBILITY.SUCCESS', journey});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: journey.body.interventionId});
  } catch (error) {
    yield put({type: 'UPDATE_JOURNEY_MOBILITY.FAILURE', error});
  }
}

export function* watchUpdateJourneyMobility() {
  yield takeEvery('UPDATE_JOURNEY_MOBILITY.REQUEST', updateJourneyMobility)
}

function* updateJourneyReception(params) {
  try {
    const journey = yield call(function() {
      return Api.put(`/journey/${params.id}/reception`, {receptionProperty: params.body})
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'UPDATE_JOURNEY_RECEPTION.SUCCESS', journey});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: journey.body.interventionId});
  } catch (error) {
    yield put({type: 'UPDATE_JOURNEY_RECEPTION.FAILURE', error});
  }
}

export function* watchUpdateJourneyReception() {
  yield takeEvery('UPDATE_JOURNEY_RECEPTION.REQUEST', updateJourneyReception)
}
